$(function() {
    if ($('#uber').hasClass('interior')) {
        // Add class to uber if calendar template
        if ($('#CalendarTemplate').length > 0){
          $('#uber').addClass('calendarView');
        }
    }
});
$(document).on('ready', function () {
  if( $('#subNavContainer')[0].children.length  < 1 ){
      $('#subNavContainer').css('display','none');
  }
});
